const filterData = [
	{
		id: 1,
		title: "Foods"
	},
	
	{
		id: 2,
		title: "Exercises"
	},
	
	{
		id: 3,
		title: "Mental Health"
	},
	
	{
		id: 4,
		title: "Health Checkups"
	}
];

export default filterData;